import { render, staticRenderFns } from "./AssaysTableControls.vue?vue&type=template&id=c13882e0&scoped=true"
import script from "./AssaysTableControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssaysTableControls.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AssaysTableControls.vue?vue&type=style&index=0&id=c13882e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13882e0",
  null
  
)

export default component.exports